export default __webpack_public_path__ + "static/media/MEDICALSERVICEUSAGEFORM.c4294e0c.png";